import { useState } from 'react';
import { Checkbox, CircularProgress, Grid, Paper, Typography } from '@material-ui/core';
import { Policies } from './components';
import { StepApi } from 'services';
import { toastMessages } from 'config/constants';
import { useCompany } from 'contexts/CompanyContext';
import { useHistory } from 'react-router-dom';
import DefaultButton from 'components/DefaultButton';
import MaiaLogo from 'components/MaiaLogo';
import MaiaText from 'components/MaiaText';
import RegisterLayout from 'pages/RegisterLayout';
import routes from 'config/routes';
import ScrollView from 'devextreme-react/scroll-view';
import sideImage from '_assets/register/Contract.svg';
import toast from 'react-hot-toast';
import useStyles from './styles';

const RegisterPolicies = () => {
  const classes = useStyles();
  const history = useHistory();
  const { currentCompany } = useCompany();

  const [areCguAccepted, setCguAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const updateRegisterStep = async () => {
    try {
      const response = await StepApi.updateStep(currentCompany.id, 'contract_check');
      return response.status === 'OK';
    } catch (e) {
      toast.error(toastMessages.error.CONTRACT_CHECKED);
      return false;
    }
  };

  const handleCancel = () => {
    if (!isSubmitting) history.goBack();
  };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    updateRegisterStep().then((accepted) => {
      setIsSubmitting(false);
      if (accepted) history.push(routes.home.root);
    });
  };

  const SideComponent = () => (
    <Grid container direction="column" style={{ height: 'auto' }}>
      <Grid container item justifyContent="center">
        <MaiaLogo />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '8vh' }}>
        <img src={sideImage} alt="Identity" width={180} />
      </Grid>

      <Grid container item justifyContent="center" style={{ marginTop: '3vh' }}>
        <Typography className={classes.text} align="center" variant="h3">
          Intégrer <MaiaText /> c’est devenir notre partenaire.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Sans engagement et sans contrainte.
        </Typography>
        <Typography className={classes.text} align="center" variant="h3" style={{ marginTop: '3vh' }}>
          Signez dès maintenant votre contrat de prestataire !
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <RegisterLayout SideComponent={<SideComponent />}>
      <Grid container direction="column" style={{ height: 'auto' }}>
        <Grid className={classes.header} container item justifyContent="center">
          <Grid className={classes.title} container item xs={12} md={9} justifyContent="center">
            <Typography variant="h1">Votre contrat</Typography>
          </Grid>

          <Grid className={classes.subtitle} container item xs={12} justifyContent="center">
            <Typography align="center" variant="subtitle1" style={{ fontSize: 20, fontWeight: 400 }}>
              Une commission de 15% est prélevée sur les ventes (hors réservation directe)
            </Typography>
          </Grid>
        </Grid>

        <Grid container item justifyContent="center" style={{ flexGrow: 1 }}>
          <Grid container item xs={12} md={10} direction="column" spacing={3}>
            <Paper className={classes.paper} elevation={0}>
              <ScrollView className={classes.view}>
                <Policies />
              </ScrollView>
            </Paper>

            <Grid container item>
              <Grid container item xs={12} alignItems="center" justifyContent="center">
                <Typography color="primary" style={{ fontSize: 24, fontWeight: 300 }}>
                  Je reconnais avoir lu les CGU et accepter le contrat qui me lie à Maïa
                </Typography>
                <Checkbox
                  color="primary"
                  checked={areCguAccepted}
                  name="cguCheckbox"
                  onChange={() => setCguAccepted(!areCguAccepted)}
                />
              </Grid>
              <Grid container item xs={12} alignItems="center" justifyContent="center">
                <Typography variant="subtitle1" style={{ fontSize: 20, fontWeight: 300 }}>
                  Le contrat est téléchargeable dans Paramètres / Gestion d'Entreprise
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid container item xs={12} justifyContent="center">
            <Grid
              container
              item
              xs={12}
              alignItems="flex-end"
              justifyContent="center"
              style={{ marginBottom: '16px', marginTop: '24px' }}
            >
              {areCguAccepted && (
                <>
                  <DefaultButton cancel onClick={handleCancel}>
                    Annuler
                  </DefaultButton>
                  <DefaultButton color="secondary" disabled={isSubmitting} onClick={handleSubmit} variant="contained">
                    {isSubmitting ? <CircularProgress size={20} /> : 'Valider'}
                  </DefaultButton>
                </>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </RegisterLayout>
  );
};

export default RegisterPolicies;
